import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import { Toaster } from "@/components/ui/sonner";

// Componente de rota protegida
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("authToken");
  return token ? children : <Navigate to="/" replace />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard page="dashboard" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cookies"
            element={
              <ProtectedRoute>
                <Dashboard page="cookies" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/contas-gmail"
            element={
              <ProtectedRoute>
                <Dashboard page="contas-gmail" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/documentacao"
            element={
              <ProtectedRoute>
                <Dashboard page="documentacao" />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
